import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/about" className="footer-link">About Us</Link></li>
            <li><Link to="/services" className="footer-link">Services & Products</Link></li>
            <li><Link to="/news" className="footer-link">Company News</Link></li>
            <li><Link to="/contact" className="footer-link">Contact & Resources</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>Email: info@zenithworldwide.com</p>
          <p>Phone: +966 56335 2717</p>
          <p>Address: Al Khobar 31952 Kingdom Of Saudi Arabia</p>
        </div>
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a href="#" className="social-link">LinkedIn</a>
            <a href="#" className="social-link">Twitter</a>
            <a href="#" className="social-link">Facebook</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Zenith World Wide Company. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
